import { createSelector } from 'reselect';
import { FORCE_NEW_EXPERIENCE } from './constants';

const featureFlagsState = (state) => state.featureFlags || { flags: {}, isFetching: false };

export const getFeatureFlags = createSelector(
  [featureFlagsState],
  (featureFlags) => featureFlags.flags || {}
);

export const isFeatureFlagsFetching = createSelector(
  [featureFlagsState],
  (featureFlags) => featureFlags.isFetching
);

export const isForceNewExperienceEnabled = createSelector(
  [getFeatureFlags],
  (flags) => flags[FORCE_NEW_EXPERIENCE] === true
);

export const getFeatureFlagByName = (state, flagName) => {
  const flags = getFeatureFlags(state);
  return flags[flagName] === true;
};

export const isCreatorForceNewExperienceEnabled = createSelector(
  [featureFlagsState],
  (featureFlags) => featureFlags.creatorForceNewExperience === true
);
